import React from 'react';
import PropTypes from 'prop-types';

const SearchAirportOfferSchema = ({
    facilityTitle,
    displayPrice,
    currencyType,
    starts,
    ends,
}) => {
    return (
        <>
            <meta itemProp="name" content="Parking" />
            <meta
                itemProp="description"
                content={`Reserved Parking at ${facilityTitle}`}
            />
            {displayPrice && <meta itemProp="price" content={displayPrice} />}
            {currencyType && (
                <meta itemProp="priceCurrency" content={currencyType} />
            )}
            <span
                itemProp="seller"
                itemScope
                itemType="http://schema.org/Organization"
            >
                <meta itemProp="name" content="SpotHero" />
                <meta itemProp="url" content="https://spothero.com" />
            </span>
            {starts && ends && (
                <>
                    <meta itemProp="validFrom" content={starts} />
                    <meta itemProp="validThrough" content={ends} />
                </>
            )}
            <meta itemProp="availability" content="http://schema.org/InStock" />
        </>
    );
};

SearchAirportOfferSchema.propTypes = {
    facilityTitle: PropTypes.string.isRequired,
    displayPrice: PropTypes.number,
    currencyType: PropTypes.string,
    starts: PropTypes.string,
    ends: PropTypes.string,
};

export default SearchAirportOfferSchema;
